import { useState } from 'react';
import React, { useEffect } from 'react';
import AOS from 'aos';
import "../../mainPages/Home/home.css";


function Categories() {

    useEffect(() => {
        AOS.init({ duration: 1000, easing: 'ease-in-out', once: true });
    }, []);
   

    const [selectedCategory, setSelectedCategory] = useState(null);

    const categories = [
        { _id: '1', categoryName: "necklace", thumbnail: "/assets/categoryIcon/necklace.webp" },
        { _id: '2', categoryName: "bracelet", thumbnail: "/assets/categoryIcon/bracelet.webp" },
        { _id: '3', categoryName: "ring", thumbnail: "/assets/categoryIcon/ring.webp" },
        { _id: '4', categoryName: "earring", thumbnail: "/assets/categoryIcon/earring.webp" }
    ];

    const handleCategoryClick = (category) => {
        setSelectedCategory(category);
        setTimeout(() => {
            const section = document.getElementById("category-section");
            if (section) {
                const yOffset = -80;
                const y = section.getBoundingClientRect().top + window.scrollY + yOffset;
                window.scrollTo({ top: y, behavior: "smooth" });
            }
        }, 200);
    };

    const products = {
        ring: [
            { src: "/assets/images-products/Rings/Ring1.webp", desc: "Luxury Gold Diamond Ring" },
            { src: "/assets/images-products/Rings/Ring2.webp", desc: "Elegant Silver Engagement Ring" },
            { src: "/assets/images-products/Rings/Ring3.webp", desc: "Classic Ruby-Studded Ring" },
            { src: "/assets/images-products/Rings/Ring4.webp", desc: "Modern Minimalist Band" }
        ],
        necklace: [
            { src: "/assets/images-products/Necklace/Necklace1.webp", desc: "Elegant Gold Necklace with Gemstones" },
            { src: "/assets/images-products/Necklace/Necklace2.webp", desc: "Exquisite Diamond Studded Necklace" }
        ],
        bracelet: [
            { src: "/assets/images-products/bracelets/Bracelet.webp", desc: "Stylish Gold Bracelet" },
            { src: "/assets/images-products/bracelets/Bracelet2.webp", desc: "Minimalist Silver Bracelet" }
        ],
        earring: [
            { src: "/assets/images-products/Earings/Earings.webp", desc: "Elegant Pearl Drop Earrings" },
            { src: "/assets/images-products/Earings/Earings2.webp", desc: "Gold Hoop Earrings" }
        ]
    };

    return (

        <>
            <section className="ShopByCategory" data-aos="fade-up">
                <h3>SHOP BY CATEGORY</h3>
                <p>Browse through your favorite categories. We have got them all!</p>
                <div className="categoryBox">
                    {categories.map(({ _id, categoryName, thumbnail }) => (
                        <div
                            key={_id}
                            className={`category-item ${selectedCategory === categoryName ? "active" : ""}`}
                            onClick={() => handleCategoryClick(categoryName)}
                            style={{ cursor: "pointer" }}
                        >
                            <img src={thumbnail} alt={`Image of ${categoryName}`} />
                            <p>{categoryName}</p>
                        </div>
                    ))}
                </div>
            </section>

            <div id="category-section">
                {selectedCategory && (
                    <section className={`${selectedCategory}-section p-6 bg-gray-100`} data-aos="fade-up">
                        <h3>{selectedCategory.charAt(0).toUpperCase() + selectedCategory.slice(1)} Collection</h3>
                        <p>Explore our exclusive {selectedCategory} collection.</p>
                        <div className="gallery grid grid-cols-2 md:grid-cols-4 gap-6">
                            {products[selectedCategory]?.map((item, index) => (
                                <div className="image-container" key={index}>
                                    <img src={item.src} alt={`${selectedCategory} ${index + 1}`} className="rounded shadow" />
                                    <div className="overlay">
                                        <span className="image-description">{item.desc}</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </section>
                )}
            </div>

        </>
    );
}

export default Categories;